import { render, staticRenderFns } from "./planVaccineConfirm.vue?vue&type=template&id=5d474139&scoped=true"
import script from "./planVaccineConfirm.vue?vue&type=script&lang=js"
export * from "./planVaccineConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d474139",
  null
  
)

export default component.exports